import $ from 'jquery';

// Connect to the remote server.
const DOMAIN = 'https://paintedturtle.ddsandbox.net';

export default class {
  constructor(context) {
    // Grab all image tags.
    const $localImages = $('.node img', context);

    // Iterate.
    $localImages.each((i, image) => {
      const localImage = new Image();

      // Add an error handler to manage the fetch of the remote source image.
      localImage.addEventListener('error', () => {
        let remotePath = `${DOMAIN}/sites/main/files`;

        // Support for both images within the file root and within the main-images directory.
        if (/main-images/gi.test(image.src)) {
          remotePath += '/main-images';
        }

        // Load remote image in new browser tab.
        const remoteImage = remotePath + image.src.substr(image.src.lastIndexOf('/'));
        window.open(remoteImage);
      });

      // Re-run to see if the image fails to load. If so, the error handler will be triggered.
      localImage.src = image.src;
    });
  }
}
